import { AppStepMapping } from 'App.interface';
import { choosePostContactStep } from 'App.utils';

export const NEXT_STEP_MAPPING_PP: AppStepMapping = {
    'PreContact': () => 'Contact',
    'Contact': () => 'PreChooseAdvisor',
    'PreChooseAdvisor': (preset, journeyData) => choosePostContactStep(
        journeyData.folder,
    ),
    'ChooseAdvisor': () => 'PreConfirmation',
    'PreTarification': () => 'End/Off-target-product',
};

export const PREVIOUS_STEP_MAPPING_PP: AppStepMapping = {
    'Contact': () => 'Contact',
    'ChooseAdvisor': () => 'Contact',
};
